import { gql } from '../__generated__/gql';

export const GET_BREEDS = gql(`
    query GetBreeds($species: CustomerBreedSpeciesEnum!) {
        breeds(filters: { species: $species }) {
            id
            name
        }
    }
`);

export const GET_COLORS = gql(`
    query GetColors($species: CustomerColorSpeciesEnum!) {
        colors(filters: { species: $species }) {
            id
            name
        }
    }
`);

export const CREATE_PATIENT = gql(`
    mutation CreatePatient($input: PatientInput!) {
        createPatient(data: $input) {
            id
        }
    }
`);

export const PATCH_PATIENT = gql(`
    mutation PatchPatient($input: PatientInputPartial!) {
        patchPatient(data: $input) {
            id
        }
    }
`);

gql(`
    fragment ExternalClinicParts on ExternalClinicType {
        id
        name
        address
        phone
    }
`);

export const CREATE_EXTERNAL_CLINIC = gql(`
    mutation CreateExternalClinic($input: ExternalClinicInput!) {
        createExternalClinic(data: $input) {
            ...ExternalClinicParts
        }
    }
`);

export const GET_EXTERNAL_CLINICS = gql(`
    query GetExternalClinics($googlePlacesId: String!) {
        externalClinics(filters: { googlePlacesId: { exact: $googlePlacesId }}) {
            ...ExternalClinicParts
        }
    }
`);

export const CREATE_INBOUND_MEDICAL_RECORD_REQUEST = gql(`
    mutation CreateInboundMedicalRecordRequest($input: InboundMedicalRecordRequestInput!) {
        createInboundMedicalRecordRequest(data: $input) {
            id
        }
    }
`);

export const CREATE_ACCOUNT_CREDIT = gql(`
    mutation CreateAccountCredit($data: AccountCreditInput!) {
        createAccountCredit(data: $data) {
            id
        }
    }
`);

export const CREATE_CLINICAL_RECORD = gql(`
    mutation CreateClinicalRecord($data: ClinicalRecordInput!) {
        createClinicalRecord(data: $data) {
            id
        }
    }
`);

export const CREATE_INVOICE = gql(`
    mutation CreateInvoice($data: InvoiceInput!) {
        createInvoice(data: $data) {
            id
        }
    }
`);

export const CREATE_INVOICE_ITEMS = gql(`
    mutation CreateInvoiceItems($data: [InvoiceItemInput!]!) {
        createInvoiceItems(data: $data) {
            id
            invoice {
                id
                postTaxTotal
            }
        }
    }
`);

export const CREATE_TRANSACTION = gql(`
    mutation CreateTransaction($data: TransactionInput!) {
        createTransaction(data: $data) {
            id
            status
            reasonForFailure
        }
    }
`);

export const PATCH_INVOICE = gql(`
    mutation PatchInvoice($data: InvoiceInputPartial!) {
        patchInvoice(data: $data) {
            id
        }
    }
`);

export const CREATE_MEMBERSHIP = gql(`
    mutation CreateMembership($data: MembershipInput!) {
        createMembership(data: $data) {
            id
        }
    }
`);

export const GET_VALID_PROMO_CODE_AND_REFERRING_HOUSEHOLD = gql(`
    query GetValidPromoCodeAndReferringHousehold(
        $promoCode: String!, 
        $referredHouseholdId: String!
    ) {
        validPromoCodeAndReferringHousehold(
            promoCode: $promoCode
            referredHouseholdId: $referredHouseholdId
        ) {
            promo {
                id
                code
                isValid
                amountOff
                percentOff
            }
            referringHousehold {
                id
                householdHash
            }
        }
    }
`);
